import React, { memo } from "react"
import clsx from "clsx"
import Avatar from "./Avatar"
import { usePlanning } from "./PlanningContext"
import { formatHours } from "../lib/hours"
import { readableOn } from "../lib/colors"

const PersonPill = ({ assignment, selected }) => {
  const { handlers, usersById, projectsById, density, canWrite } = usePlanning()
  const user      = usersById.get(assignment.user_id) || null
  const color     = projectsById.get(assignment.project_id)?.color || assignment.color || "#64748B"
  const ink       = readableOn(color)
  const draggable = canWrite && !assignment.pending
  const name      = user ? user.name : I18n.t("project_planning.unknown_person")
  const tooltip   = [name, assignment.task_title, formatHours(assignment.hours), assignment.note].filter(Boolean).join("\n")

  return (
    <div
      draggable={draggable}
      title={tooltip}
      onDragStart={event => handlers.dragAssignment(assignment, event)}
      onDragEnd={handlers.dragEnd}
      onMouseDown={event => event.stopPropagation()}
      onClick={event => { event.stopPropagation(); handlers.clickAssignment(assignment, event) }}
      style={{ backgroundColor: color, color: ink }}
      className={clsx(
        "pp-chip flex items-center gap-1.5 min-w-0 rounded-full select-none transition-[transform,filter] duration-150",
        density === "compact" ? "p-[2px]" : "pl-0.5 pr-2 py-0.5 hover:brightness-110",
        draggable ? "cursor-grab active:cursor-grabbing hover:-translate-y-px" : "cursor-pointer",
        assignment.pending && "pp-pending",
        selected && "ring-2 ring-brand-500 ring-offset-1",
      )}
    >
      <Avatar user={user} size={density === "compact" ? "sm" : "xs"} title={tooltip} plain />
      {density !== "compact" && (
        <span className="ml-auto shrink-0 text-[10.5px] font-semibold tabular-nums">{formatHours(assignment.hours)}</span>
      )}
    </div>
  )
}

export default memo(PersonPill)
